import React, { FC } from 'react';
import { useRouter } from 'next/router';
import s from './styles.module.scss';
import { SpriteIcon } from '@components/Sprites/SpriteIcon';
import classNames from 'classnames';
import { useTranslation } from '@hooks/useTranslation';
import { Button } from '../Button/Button';
import { LinksEnum } from '@specs/navigation';
type UnavailablePostProps = {
  className?: string;
};
export const UnavailablePost: FC<UnavailablePostProps> = ({
  className
}) => {
  const {
    translate: tr
  } = useTranslation();
  const router = useRouter();
  const handleGoToMain = () => {
    router.push(LinksEnum.FEED_POSTS);
  };
  return <div className={classNames(s.unavailablePost, className)} data-sentry-component="UnavailablePost" data-sentry-source-file="UnavailablePost.tsx">
            <SpriteIcon className={s.unavailablePost__icon} colored name={'coming_soon'} data-sentry-element="SpriteIcon" data-sentry-source-file="UnavailablePost.tsx" />

            <div className={s.unavailablePost__body}>
                <p className={s.unavailablePost__title}>{tr({
          id: 'unavailable.post.title'
        })}</p>
                <p className={s.unavailablePost__text}>{tr({
          id: 'unavailable.post.text'
        })}</p>

                <Button id='default_button' color='Black' size='large' onClick={handleGoToMain} data-sentry-element="Button" data-sentry-source-file="UnavailablePost.tsx">
                    {tr({
          id: 'btn.go.to.main'
        })}
                </Button>
            </div>
        </div>;
};